"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstFromGroup = void 0;
const operators_1 = require("rxjs/operators");
const logger_1 = require("../logger");
const rxjs_1 = require("rxjs");
function firstFromGroup() {
    return (0, rxjs_1.pipe)((0, operators_1.map)((group) => {
        if (!Array.isArray(group)) {
            logger_1.logger.error(`firstFromGroup must be piped an array`);
            return group;
        }
        return group[0];
    }));
}
exports.firstFromGroup = firstFromGroup;
//# sourceMappingURL=first_from_group.js.map